<div class="main-admin">
  <div class="nav-tabs">
    <ng-container *ngFor="let tab of tabs">
      <a *ngIf="(tab.admin_link || roleLogChainAdmin) && tab.access"
        [routerLink]="[roleLogChainAdmin ? tab.logchain_link : tab.admin_link]" routerLinkActive="active"
        class="tab" [ngClass]="{'_active': checkActive(tab)}"
      >{{tab.title | translate}}</a>
    </ng-container>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
